class Navigation {
  constructor($element) {
    this.$element = $element;
    this.element = $element[0];

    if (!this.element) {
      return;
    }

    this.openButton = document.querySelector("[data-navigation-open]");
    this.closeButton = this.element.querySelector("[data-navigation-close]");

    this.bindEvents();
  }

  bindEvents() {
    this.openButton?.addEventListener("click", () => {
      this.open();
    });

    this.closeButton?.addEventListener("click", () => {
      this.close();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.close();
      }
    });
  }

  open() {
    this.element.classList.add("is-open");
    this.element.setAttribute("aria-hidden", "false");
    this.openButton?.setAttribute("aria-expanded", "true");

    document.body.classList.add("navigation-open");
  }

  close() {
    this.element.classList.remove("is-open");
    this.element.setAttribute("aria-hidden", "true");
    this.openButton?.setAttribute("aria-expanded", "false");

    document.body.classList.remove("navigation-open");
  }
}

export default Navigation;
